import * as React from 'react';

const SvgCancellations = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={'1em'}
    height={'1em'}
    viewBox={'0 0 34 34'}
    {...props}
  >
    <path
      d="M17 0C7.611 0 0 7.611 0 17s7.611 17 17 17 17-7.611 17-17C33.99 7.615 26.385.01 17 0Zm5.667 20.665a1.417 1.417 0 1 1-2.002 2.002L17 19.003l-3.664 3.664a1.417 1.417 0 0 1-2.003-2.004L14.997 17l-3.664-3.664a1.417 1.417 0 0 1 2.003-2.003L17 14.997l3.665-3.664a1.417 1.417 0 1 1 2.002 2.002L19.003 17l3.664 3.665Z"
      fill='currentColor'
    />
  </svg>
);
export default SvgCancellations;
